import { useMemo } from 'react';
import PickerButton from '../PickerButton';
export default function useComponents(components) {
  return useMemo(() => Object.assign({
    button: PickerButton
  }, components), [components]);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/generatePicker/useComponents.js
// module id = 783
// module chunks = 0